import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Config } from '../contabilidad/config/config';
@Injectable()
export class DashboardService {
  dataUrl = Config.URL_BASE;
  constructor(private http: HttpClient) {
  }

  tc5dias(moneda: String): Observable<any> {
    let url_ = this.dataUrl + '/ctb_tc/get/' + moneda;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getTc(moneda: String, idEmp: number): Observable<any> {
    let url_ = this.dataUrl + '/ctb_tc/get/' + moneda + '/' + idEmp;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  dashboard(idEmp: number, periodos: number): Observable<any> {
    let url_ = this.dataUrl + '/dashboard/dashboard/' + idEmp + '/' + periodos;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  est_fis_iva(idEmp: number, periodos: number): Observable<any> {
    let url_ = this.dataUrl + '/dashboard/est_fis_iva/' + idEmp + '/' + periodos;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  ctb_grph_ven_eje(idEmp: number, periodos: number): Observable<any> {
    let url_ = this.dataUrl + '/dashboard/ctb_grph_ven_eje/' + idEmp + '/' + periodos;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
}
